import jwt_decode from 'jwt-decode';
import { initializeAxios } from '../services/_api/shared';
import * as UserType from '../constants/UserType';
import { regions } from '../constants/region';

const USER_TOKEN_KEY = 'USER_TOKEN';
const ADMIN_TOKEN_KEY = 'ADMIN_TOKEN';
const LOGIN_MODE_KEY = 'LOGIN_MODE';
const ADMIN_LOGIN_MODE = 'ADMIN';
const USER_LOGIN_MODE = 'USER';
const REGION_KEY = 'REGION';

const getSessionItem = (item) => window.localStorage.getItem(item);

const isAdminToken = (token) => {
  const tokenData = jwt_decode(token).data;
  return tokenData.jobFunction === UserType.ADMIN.name;
};

const setLoginMode = (isAdmin) => {
  window.localStorage.setItem(
    LOGIN_MODE_KEY,
    isAdmin ? ADMIN_LOGIN_MODE : USER_LOGIN_MODE
  );
};

const getLoginMode = () => getSessionItem(LOGIN_MODE_KEY);

const setRegion = (region) => window.localStorage.setItem(REGION_KEY, region);
const getRegion = () => getSessionItem(REGION_KEY);

const storeIsAuthenticated = (token) => {
  const isAdmin = isAdminToken(token);
  window.localStorage.setItem(
    isAdmin ? ADMIN_TOKEN_KEY : USER_TOKEN_KEY,
    token
  );

  setLoginMode(isAdmin);
  initializeAxios(isAdmin);

  if (!getRegion()) {
    setRegion(regions.USA);
  }
};

const isAuthenticated = () => {
  const loginMode = getSessionItem(LOGIN_MODE_KEY);

  if (!!loginMode)
    return !!getSessionItem(
      loginMode === ADMIN_LOGIN_MODE ? ADMIN_TOKEN_KEY : USER_TOKEN_KEY
    );

  return false;
};

const getAuthToken = (isAdmin) =>
  getSessionItem(isAdmin ? ADMIN_TOKEN_KEY : USER_TOKEN_KEY);

const getUserField = (fieldName) => getUser()[fieldName];

const getUser = () => {
  const token = getAuthToken(getLoginMode() === ADMIN_LOGIN_MODE);
  return !!token ? jwt_decode(token).data : {};
};

const hasAnyUserType = (userTypes) => userTypes.filter(isUserType).length > 0;

const isUserType = (userType) => getUser().jobFunction === userType.name;

const getUserType = () => getUser().jobFunction;

const getBranchRoles = () => getUser().branchRoles;

const getBranchRole = (branchCode) => getUser().branchRoles[branchCode];

const getBranchesForRole = (role) =>
  Object.entries(getBranchRoles()).reduce((prevValue, currValue) => {
    if (currValue[1] === role) {
      prevValue.push(currValue[0]);
    }
    return prevValue;
  }, []);

const clearAllItems = () => window.localStorage.clear();

const hasDualLoginAccess = () =>
  !!getSessionItem(ADMIN_TOKEN_KEY) && !!getSessionItem(USER_TOKEN_KEY);

const isAdminMode = () => getLoginMode() === ADMIN_LOGIN_MODE;

export {
  storeIsAuthenticated,
  isAuthenticated,
  getAuthToken,
  clearAllItems,
  getUserField,
  getUser,
  hasAnyUserType,
  isUserType,
  getUserType,
  hasDualLoginAccess,
  setLoginMode,
  isAdminMode,
  setRegion,
  getRegion,
  getBranchRoles,
  getBranchesForRole,
  getBranchRole
};
